import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import api from '../utils/api';

export default function Login() {
  const [form, setForm] = useState({ username: '', password: '' });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(''); setLoading(true);
    try {
      const { data } = await api.post('/auth/login', form);
      login(data.user, data.token);
      navigate('/');
    } catch (err) {
      setError(err.response?.data?.message || 'خطا در ورود');
    } finally { setLoading(false); }
  };

  return (
    <div style={{
      minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center',
      background: 'linear-gradient(135deg, #0e3460 0%, #1a5276 100%)'
    }}>
      <div style={{ background: 'white', borderRadius: 16, padding: 40, width: 380, boxShadow: '0 20px 60px rgba(0,0,0,0.3)' }}>
        <div style={{ textAlign: 'center', marginBottom: 32 }}>
          <div style={{ fontSize: 48, marginBottom: 12 }}>🌾</div>
          <h1 style={{ color: 'var(--primary)', marginBottom: 4 }}>فروشگاه مواد خوارکی محمدی</h1>
          <p style={{ color: 'var(--text-muted)', fontSize: 13 }}>برای ادامه وارد شوید</p>
        </div>
        {error && <div className="alert alert-danger">{error}</div>}
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label className="form-label">نام کاربری</label>
            <input className="form-control" value={form.username}
              onChange={e => setForm({...form, username: e.target.value})} placeholder="نام کاربری" />
          </div>
          <div className="form-group">
            <label className="form-label">رمز عبور</label>
            <input className="form-control" type="password" value={form.password}
              onChange={e => setForm({...form, password: e.target.value})} placeholder="رمز عبور" />
          </div>
          <button type="submit" className="btn btn-primary" style={{ width: '100%', padding: '12px', fontSize: 15, marginTop: 8 }} disabled={loading}>
            {loading ? 'در حال ورود...' : '🔐 ورود به سیستم'}
          </button>
        </form>
      </div>
    </div>
  );
}
